import type { QueryString } from '../types.ts'

export default function isLoadedInAppView(query: QueryString) {
  const { NEGOTIATORAPP, negotiatorapp } = query
  return NEGOTIATORAPP !== undefined || negotiatorapp !== undefined
}
